import { render, staticRenderFns } from "./mcuInterface.vue?vue&type=template&id=06252c6e&scoped=true&"
import script from "./mcuInterface.vue?vue&type=script&lang=js&"
export * from "./mcuInterface.vue?vue&type=script&lang=js&"
import style0 from "./mcuInterface.vue?vue&type=style&index=0&id=06252c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06252c6e",
  null
  
)

export default component.exports